"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _reactIntersectionObserver = require("react-intersection-observer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Wrapper",
  class: "pl-w17u3ue5",
  vars: {
    "w17u3ue5-0": [({
      zIndex = 0
    }) => zIndex],
    "w17u3ue5-1": [({
      mobileWidth = 'clamp(11rem, 20vw, 24.375rem)'
    }) => mobileWidth],
    "w17u3ue5-2": [({
      mobileHeight = 'clamp(11rem, 20vw, 24.375rem)'
    }) => mobileHeight],
    "w17u3ue5-3": [({
      mobileTop = 'auto'
    }) => mobileTop],
    "w17u3ue5-4": [({
      mobileRight = 'auto'
    }) => mobileRight],
    "w17u3ue5-5": [({
      mobileBottom = 'auto'
    }) => mobileBottom],
    "w17u3ue5-6": [({
      mobileLeft = 'auto'
    }) => mobileLeft],
    "w17u3ue5-8": [({
      desktopWidth = 'clamp(11rem, 20vw, 24.375rem)'
    }) => desktopWidth],
    "w17u3ue5-9": [({
      desktopHeight = 'clamp(11rem, 20vw, 24.375rem)'
    }) => desktopHeight],
    "w17u3ue5-10": [({
      desktopTop = 'auto'
    }) => desktopTop],
    "w17u3ue5-11": [({
      desktopRight = 'auto'
    }) => desktopRight],
    "w17u3ue5-12": [({
      desktopBottom = 'auto'
    }) => desktopBottom],
    "w17u3ue5-13": [({
      desktopLeft = 'auto'
    }) => desktopLeft]
  }
});
const Decor = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Decor",
  class: "pl-dbq3g5a",
  vars: {
    "dbq3g5a-0": [({
      image = 'none'
    }) => `url(${image})`],
    "dbq3g5a-1": [({
      animationDelay = '0s'
    }) => animationDelay]
  }
});

/**
 * ImageDecor Component.
 *
 * @param {Object} props React props
 * @param {string} props.imgUrl Image URL
 * @param {string} props.desktopTop Top position for desktop
 * @param {string} props.desktopRight Right position for desktop
 * @param {string} props.desktopBottom Bottom position for desktop
 * @param {string} props.desktopLeft Left position for desktop
 * @param {string} props.mobileTop Top position for mobile
 * @param {string} props.mobileRight Right position for mobile
 * @param {string} props.mobileBottom Bottom position for mobile
 * @param {string} props.mobileLeft Left position for mobile
 * @param {number} props.zIndex Z-index for the component
 * @param {string} props.animationDelay Animation delay
 * @param {React.ReactNode} props.children Children nodes
 * @param {boolean} props.triggerOnce Trigger background-visible once
 * @param {Object} props.style Inline styles
 * @param {string} props.className Classname
 * @returns {React.ReactElement} ImageDecor Component
 * @public
 */
function ImageDecor({
  imgUrl,
  mobileWidth,
  mobileHeight,
  desktopHeight,
  desktopWidth,
  desktopTop,
  desktopRight,
  desktopBottom,
  desktopLeft,
  mobileTop,
  mobileRight,
  mobileBottom,
  mobileLeft,
  zIndex,
  animationDelay = '.25s',
  children,
  triggerOnce = false,
  style,
  className
}) {
  const [refBackground, inViewBackground] = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true,
    rootMargin: '600px 0px 0px 0px',
    fallbackInView: true
  });
  const [refAnimated, inViewAnimated] = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: triggerOnce,
    rootMargin: '100px 0px 100px 0px',
    fallbackInView: true
  });
  const setRefs = (0, _react.useCallback)(node => {
    refBackground(node);
    refAnimated(node);
  }, [refBackground, refAnimated]);
  if (!imgUrl) return null;
  const classNames = [className, inViewBackground && 'background-visible', 'animated', inViewAnimated && 'visible'].filter(Boolean).join(' ');
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    style: style,
    className: className,
    desktopTop: desktopTop,
    desktopRight: desktopRight,
    desktopBottom: desktopBottom,
    desktopLeft: desktopLeft,
    mobileTop: mobileTop,
    mobileRight: mobileRight,
    mobileBottom: mobileBottom,
    mobileLeft: mobileLeft,
    zIndex: zIndex,
    desktopWidth: desktopWidth,
    desktopHeight: desktopHeight,
    mobileWidth: mobileWidth,
    mobileHeight: mobileHeight
  }, /*#__PURE__*/_react.default.createElement(Decor, {
    ref: setRefs,
    "data-cy": "image-decor",
    className: classNames.trim(),
    image: imgUrl,
    animationDelay: animationDelay,
    role: "img",
    "aria-label": "decorative image"
  }, children));
}
var _default = exports.default = ImageDecor;
ImageDecor.propTypes = {
  imgUrl: _propTypes.default.string,
  desktopWidth: _propTypes.default.string,
  desktopHeight: _propTypes.default.string,
  mobileWidth: _propTypes.default.string,
  mobileHeight: _propTypes.default.string,
  desktopTop: _propTypes.default.string,
  desktopRight: _propTypes.default.string,
  desktopBottom: _propTypes.default.string,
  desktopLeft: _propTypes.default.string,
  mobileTop: _propTypes.default.string,
  mobileRight: _propTypes.default.string,
  mobileBottom: _propTypes.default.string,
  mobileLeft: _propTypes.default.string,
  zIndex: _propTypes.default.number,
  breakpoint: _propTypes.default.string,
  animationDelay: _propTypes.default.string,
  children: _propTypes.default.node,
  triggerOnce: _propTypes.default.bool,
  style: _propTypes.default.object,
  className: _propTypes.default.string
};